import React, { useEffect } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useParams } from 'react-router-dom';
import R from 'ramda';
import Helmet from 'Components/Helmet';
import Body from 'Pages/Market/Body';
import DivisionWarehouse from 'Pages/Market/DivisionWarehouse';

export default () => {
  const { productId } = useParams();
  const product = useStoreState(state => state.auth.productById(productId));
  const p_id = R.prop('p_id', product);

  const saveFilter = useStoreActions(state => state.market.saveFilter);
  const resetFilter = useStoreActions(state => state.market.resetFilter);
  const recoverFilter = useStoreActions(state => state.market.recoverFilter);
  const setData = useStoreActions(action => action.market.setData);

  useEffect(() => {
    saveFilter();
    resetFilter();
    p_id && setData({ fProducts: [p_id] });
    return () => {
      recoverFilter();
    };
  }, [recoverFilter, saveFilter, resetFilter, p_id]);

  const title = p_id
    ? `Market depth - ${R.prop('name', product)}`
    : 'Marketplace';
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <h2 className="mb-20">
        {title}
        {product && R.hasPath(['owner', 'name'], product) && (
          <span className="nowrap"> - {product.owner.name}</span>
        )}
      </h2>

      <DivisionWarehouse />

      <div className="market sb-175 ml--20 mr--20">
        <Body />
      </div>
    </>
  );
};
